import React, { useEffect, useState } from "react";
import Innerbanner from "../../components/inner-banner";
import Image from "../../components/ui/image";
import { Images } from "../../lib/images";
import { Link } from "react-router-dom";
import { getClubLists, getLeagueList, getRegionList } from "../../Services/apis";
import Loader from "../../components/loader";
import { sortByLabel, sortLeagueOptions } from "../../lib/sorters";
import MultiSelect from "../league-table/multiselect";

const options = [
  { value: "option1", label: "Option 1", },
  { value: "option2", label: "Option 2", },
  { value: "option3", label: "Option 3", },
];

// Sample team data
// const teamsData = [
//   { id: 1, name: "Arsenal FC", country: "England", score: 98.5 },
//   { id: 2, name: "Barcelona", country: "Spain", score: 96.2 },
//   { id: 3, name: "Bayern Munich", country: "Germany", score: 94.8 },
//   { id: 4, name: "Juventus", country: "Italy", score: 92.1 },
//   { id: 5, name: "PSG", country: "France", score: 90.3 },
//   { id: 6, name: "Chelsea", country: "England", score: 88.7 },
//   { id: 7, name: "Real Madrid", country: "Spain", score: 97.9 },
//   { id: 8, name: "Liverpool", country: "England", score: 89.6 },
//   { id: 9, name: "AC Milan", country: "Italy", score: 85.2 },
// ];

type FilterOption = { value: string; label: string };

const ClubProfiles: React.FC = () => {
  const headingText = "Club Profiles";
  const[loading, setLoading] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState<FilterOption[]>([]);
  const [selectedLeague, setSelectedLeague] = useState<FilterOption[]>([]);
const [teamsData, setTeamsData] = useState<any[]>([]);
const [regionData, setRegionData] = useState<FilterOption[]>([]);
const [leagueData, setLeagueData] = useState<FilterOption[]>([]);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
const [totalCount, setTotalCount] = useState(0);
const itemsPerPage = 18; // how many clubs you show per page

// Derived value
const totalPages = Math.ceil(totalCount / itemsPerPage); 

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
//  const currentTeams = teamsData.slice(startIndex, endIndex);
const FetchClubList = async (page:number) => {
  try {
    setLoading(true);
    const regionValues = selectedRegion.map((r) => r.value).join(",");
    const leagueValues = selectedLeague.map((l) => l.value).join(",");
    const response = await getClubLists(regionValues,leagueValues,page); 
    setTeamsData(response?.data);
     setCurrentPage(response?.pagination?.current_page);
setTotalCount(response?.pagination?.total || 1);
     setLoading(false);
    return response.data;
  } catch (error) {
    setLoading(false);
    console.error("Error fetching club details:", error);
    throw error;
  }
}
useEffect(() => {
  FetchClubList(currentPage);
  getRegionData();
  getLeagueData();
}, [selectedRegion,selectedLeague,currentPage]);
const getRegionData = async () => {
  try {
    const res = await getRegionList(); // adjust to your service
    const formatted: FilterOption[] = res.data.map((region: string) => ({
      value: region,
      label: region,
    }));
    setRegionData(sortByLabel(formatted));
  } catch (err) {
    console.error("Error fetching regions:", err);
  }
};

const getLeagueData = async () => {
  try {
    const res = await getLeagueList(); // adjust to your service
    const formatted: FilterOption[] = res.data.map((league: string) => ({
      value: league,
      label: league,
    }));
    setLeagueData(sortLeagueOptions(formatted));
  } catch (err) {
    console.error("Error fetching leagues:", err);
  }
};
  return (
    <div className="w-full">
      {loading ? <Loader/> : null}
      <Innerbanner bnrHeading={headingText} />

      <section className="bg-background p-5">
        <div className="container mx-auto pb-10">
          {/* Filters */}
          <div className="w-full border-b border-gray-300 pb-3 mb-3">
            <div className="flex gap-3 pb-3 flex-wrap">
              <MultiSelect
                options={regionData}
                placeholder="Select region"
                value={selectedRegion}
                onChange={setSelectedRegion}
              />
              <MultiSelect
                options={leagueData}
                placeholder="Select league"
                value={selectedLeague}
                onChange={setSelectedLeague}
              />
            </div>

            {/* Selected Items Display */}
            {(selectedRegion.length > 0 || selectedLeague.length > 0) && (
              <div className="mt-3 flex flex-wrap gap-2 border rounded-lg p-3">
                {selectedRegion.length > 0 && (
                  <div className="flex flex-wrap gap-2 items-center">
                    <span className="text-xs font-semibold text-gray-600">Regions:</span>
                    {selectedRegion.map((item) => (
                      <span
                        key={item.value}
                        className="bg-green-600 text-white px-3 py-1 rounded-full text-sm flex items-center gap-2"
                      >
                        {item.label}
                        <button
                          onClick={() => {
                            const updated = selectedRegion.filter(
                              (r) => r.value !== item.value,
                            );
                            setSelectedRegion(updated);
                          }}
                          className="text-red-300 font-bold hover:text-red-100"
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                )}
                
                {selectedLeague.length > 0 && (
                  <div className="flex flex-wrap gap-2 items-center">
                    <span className="text-xs font-semibold text-gray-600">Leagues:</span>
                    {selectedLeague.map((item) => (
                      <span
                        key={item.value}
                        className="bg-purple-600 text-white px-3 py-1 rounded-full text-sm flex items-center gap-2"
                      >
                        {item.label}
                        <button
                          onClick={() => {
                            const updated = selectedLeague.filter(
                              (l) => l.value !== item.value,
                            );
                            setSelectedLeague(updated);
                          }}
                          className="text-red-300 font-bold hover:text-red-100"
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Grid */}
          <div className="grid grid-cols-3 gap-5 pt-8">
            {teamsData.length > 0 ? (
              teamsData.map((team, index) => (
                <Link
                  to="/club-profile/details"
                  state={{ team }}
                  key={team.club_id || team.id || index}
                  className="col-span-3 md:col-span-1 bg-white rounded-xl p-5"
                >
                  <div className="flex items-center justify-between pt-5">
                  <span className="inline-block border border-redBtn rounded-full px-2 text-sm font-medium text-redBtn">
                    {/* <Image src={Images.Cup} alt="" className="inline me-1 w-3" />*/}# 
                    {team?.rank}
                  </span>
                  <Image
                     src={team?.logo_url || Images.Image}
                  alt={team?.club_name || "No Image"}
                    className="w-10 h-10 object-contain"
                    width={40}
                    height={40}
                    fallbackSrc={Images.Image}
                  />
                  </div>
                  <h5 className="text-base font-medium text-black pt-3">
                    {team?.club_name}
                  </h5>
                  <p className="text-sm text-greyColor">{team?.country}</p>
                  <div className="flex items-center justify-between pt-5">
                    <span className="font-medium text-sm text-black">
                      Titan Score
                    </span>
                    <span className="font-bold text-lg">{team?.titan_score}</span>
                  </div>
                </Link>
              ))
            ) : (
              <div className="col-span-3 text-center py-12">
                <p className="text-lg font-medium text-gray-500">No clubs available</p>
              </div>
            )}
          </div>

          {/* Pagination Bar */}
          <div className="bg-background pt-1 mt-6">
            <div className="flex items-center justify-between bg-darkBlue text-white font-medium text-base px-4 py-2 rounded-b-lg">
              {/* Page info */}
              <span className="font-normal text-sm md:text-base">
                Page {currentPage} of {totalPages} 
                {/* | Showing{" "} {Math.min(endIndex, teamsData.length)} of {teamsData.length} */}
              </span>

              {/* Pagination buttons */}
              <div className="flex items-center gap-2">
                {/* Prev */}
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                  className="disabled:opacity-50"
                >
                  <Image
                    alt=""
                    src={Images.Pgprev}
                    className="inline w-5 invert brightness-110 contrast-125"
                  />
                </button>

                {/* Numbered pages */}
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (page) => (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`border-none px-1 py-1 ${
                        currentPage === page ? "text-customBlue" : "text-white"
                      }`}
                    >
                      {page}
                    </button>
                  )
                )}

                {/* Next */}
                <button
                  disabled={currentPage === totalPages}
                  onClick={() =>
                    setCurrentPage((p) => Math.min(p + 1, totalPages))
                  }
                  className="disabled:opacity-50"
                >
                  <Image
                    alt=""
                    src={Images.Pgnext}
                    className="inline w-5 invert brightness-110 contrast-125"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ClubProfiles;
